
import { nextTick, reactive } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import NCheckbox from '@/uikit/checkbox/NCheckbox.vue';
import NInputNumber from '@/uikit/input-number/NInputNumber.vue';
import NSelect from '@/uikit/select/NSelect.vue';
import NSlider from '@/uikit/slider/NSlider.vue';
import VideoPlayerState from '@/components/video-player/VideoPlayerState';
import { generateVideoResolutions } from '@/components/video-player/utils/generate-resolutions';

@Options({
  name: 'VideoPlayerSettings',
  components: { NCheckbox, NInputNumber, NSelect, NSlider }
})
export default class VideoPlayerSettings extends Vue {
  @Prop({ type: Object, required: true })
  readonly settings!: VideoPlayerState;

  get resolutionsItems() {
    return generateVideoResolutions(this.settings.camera?.frame_width || 1920, this.settings.camera?.frame_height || 1080).map((item) => ({
      label: item,
      value: item
    }));
  }
}
